<div class="viz-toolbar">
  <!-- Run All/Cancel/Stop -->
  <div class="button-group">
    <div
      class="capra-tooltip"
      capraTooltip
      [tooltipContent]="isCancelling ? 'Stopping' : isRunning ? 'Stop' : 'Run all'"
      tooltipPlacement="bottom"
      tooltipDelay="500"
      tooltipSize="mini"
    >
      <capra-button
        class="btn-run-all capra-button"
        [ngClass]="{
          running: runAllIcon === 'icon-stop',
          ready: runAllIcon === 'icon-play',
        }"
        variant="secondary"
        color="neutral"
        [icon]="runAllIcon"
        size="small"
        [text]="isCancelling ? 'Stopping...' : isRunning ? 'Stop' : 'Run all'"
        [disabled]="!isRunning && !canRun"
        (click)="runOrCancelNotebook()"
      >
      </capra-button>
    </div>
    <!-- Restart Session -->
    <div
      class="capra-tooltip"
      capraTooltip
      tooltipContent="Restart Session"
      tooltipPlacement="bottom"
      tooltipSize="mini"
      tooltipDelay="500"
      [tooltipIsDisabled]="!(canRestartSession$ | async)"
    >
      <capra-button
        class="capra-button"
        variant="secondary"
        color="neutral"
        [disabled]="!(canRestartSession$ | async)"
        size="small"
        text="Restart"
        (click)="restartSession()"
      >
      </capra-button>
    </div>
  </div>

  <div class="button-group">
    <!-- Run Cell -->
    <mode-notebook-run-cell-button
      [cellToken]="cellToken$ | async"
      [nextCellToken]="nextCellToken$ | async"
      [canRun]="(canRunCell$ | async) && !(isSelectedCellExporting$ | async)"
      (runCell)="runCell($event)"
    >
    </mode-notebook-run-cell-button>

    <!-- Insert New Cell -->
    <mode-notebook-add-cell-button
      [cellToken]="cellToken$ | async"
      [nextCellToken]="nextCellToken$ | async"
      (insertCellAbove)="insertCellAbove($event)"
      (insertCellBelow)="insertCellBelow($event)"
    >
    </mode-notebook-add-cell-button>

    <!-- Add/Remove from Layout -->
    <mode-notebook-included-report-cell-button
      *ngIf="!thoughtspotIntegrated && !(enableNotebookExportDatasets$ | async)"
      [cellToken]="cellToken$ | async"
      [disabled]="!(hasResult$ | async)"
      [state]="isInLayout$ | async"
      (toggle)="addRemoveFromLayout($event)"
    >
    </mode-notebook-included-report-cell-button>

    <!-- Use Output Button -->
    <mode-notebook-use-output-menu
      *ngIf="enableNotebookExportDatasets$ | async"
      [cellToken]="cellToken$ | async"
      [disabled]="!(hasResult$ | async) || (isSelectedCellExporting$ | async)"
      [isOutputUsed]="isInLayout$ | async"
      (toggle)="addRemoveFromLayout($event)"
    >
    </mode-notebook-use-output-menu>
  </div>

  <div class="button-group">
    <!-- More Dropdown -->
    <mode-notebook-toolbar-more-dropdown
      [exportLink]="notebookContentLink$ | async"
      [disableHideOutput]="!(canHideOutput$ | async)"
      (hideOutput)="clearCellOutputs()"
    >
    </mode-notebook-toolbar-more-dropdown>
  </div>
</div>
